import { VirtualList } from '@epam/promo';
import {
  useModal,
  useRecognitionDeleteQuery,
  useRecognitionSwitcher,
} from 'hooks';
import { validateHTML } from 'hooks/helpers/common';
import { Recognition } from 'models/recognition.model';
import { useNavigate } from 'react-router-dom';
import { recognitionRoutes } from 'router/recognitionRoutes';
import { setDraftRecognition, useRecognitionStore } from 'store/recognition';
import { Card } from '../Card';
import css from './CardList.module.scss';

export const CardList = ({ items }: { items: Recognition[] }) => {
  const navigate = useNavigate();
  const switchRecognition = useRecognitionSwitcher();
  const modal = useModal();
  const draftRecognition = useRecognitionStore((state) => state.draft);
  const { mutate: deleteRecognition, discardDraft } =
    useRecognitionDeleteQuery();

  const onCardClick = (item: Recognition) => {
    setDraftRecognition(item);
    navigate(recognitionRoutes.recognitionId(item.id));
  };

  return (
    <VirtualList
      cx={[css.list, css.input__container]}
      role="listbox"
      rows={
        items.map((item) => (
          <Card
            key={item.id}
            isActive={item.id === draftRecognition.id}
            item={item}
            onClick={() => {
              if (item.id !== draftRecognition.id)
                switchRecognition({
                  onSuccess: () => onCardClick(item),
                  onAbort: () => {
                    navigate(recognitionRoutes.recognitionId(item.id));
                  },
                });
            }}
            onDelete={() =>
              item.id
                ? modal.delete({
                    text: `Are you sure you want to Delete ${
                      item.title
                        ? `"${validateHTML(item.title)}"`
                        : 'this recognition'
                    }?`,
                    highlights: [
                      `${
                        item.title
                          ? `"${validateHTML(item.title)}"`
                          : 'this recognition'
                      }`,
                      'Delete',
                    ],
                    onSuccess: () => deleteRecognition(item.id),
                  })
                : modal.delete({
                    text: 'Are you sure you want to Delete this draft?',
                    highlights: ['Delete', 'draft'],
                    onSuccess: () => discardDraft(),
                  })
            }
          />
        )) || []
      }
      rowsCount={items.length}
      value={{ topIndex: 0 }}
      onValueChange={() => {}}
    />
  );
};
